<template>
    <header
        class="z-50 block bg-white fixed top-0 left-0 w-full print:hidden text-gray"
        ref="mainHeader"
        :class="{
            '!bg-blue text-white': isImpersonating,
            'border-b border-gray-150': !isImpersonating,
        }"
    >
        <!-- Navbar -->
        <div class="wrap relative z-100 flex h-12 at1024:h-[70px]">
            <div class="flex items-center flex-grow basis-1/4">
                <div class="hidden at1024:flex items-center">
                    <Link class="shrink-0" :href="route('web.home')">
                        <span class="sr-only">{{ $t("SECLOCK") }}</span>
                        <BaseSvg
                            :name="isImpersonating ? 'seclock-logo-horiz-white' : 'seclock-logo-horiz-gray'"
                            class="w-44"
                            aria-hidden="true"
                        />
                    </Link>
                    <span v-if="!isImpersonating" class="w-44 text-center text-base hidden at1350:block">800.847.5625</span>
                </div>
                <MenuToggleButton />
                <StopImpersonationButton class="ml-6" />
            </div>  
            <MainNav />
            <SecondaryNav />
        </div>
    </header>
</template>
<script setup>
import { useDialog } from "@/Composables";
import { onMounted, ref, computed } from "vue";
import { MenuToggleButton, MainNav, SecondaryNav, BaseSvg, StopImpersonationButton } from "@/Components";
import { usePage } from "@inertiajs/vue3";

const isImpersonating = computed(() => usePage().props.impersonating);
const mainHeader = ref(null);

onMounted(() => {
    // toggleAppModeData.value.is_dark_mode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const prevWidth = mainHeader.value.width;

    const observer = new ResizeObserver((entries) => {
        document.documentElement.style.setProperty(
            "--header-height",
            entries[0].target.offsetHeight + "px"
        );
        document.getElementById("dialogs").classList.add("marketing-layout");
        document.getElementById("dialogs").classList.remove("sourcing-layout");
        const width = entries[0].borderBoxSize?.[0].inlineSize;
        if (typeof width === "number" && Math.abs(prevWidth - width) > 75) {
            useDialog().forceClose();
        }
    });

    observer.observe(mainHeader.value);

    document.body.classList.add("marketing-layout");
    document.body.classList.remove(
        "bg-white",
        "text-gray-800",
        "dark:bg-gray-785",
        "dark:text-white",
        "sourcing-layout"
    );
});
</script>
